import { InjectionToken } from '@angular/core';

export const PROMOTIONS_API_URL = new InjectionToken<string>('PROMOTIONS_API_URL');
